export default __webpack_public_path__ + "static/img5-5aaff4a5c695f3a8f826a5735a0a8cbd.png";